module.exports = __webpack_public_path__ + "assets/media/star.3e155d5b.svg";